// Angular
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// External
import { ApiService } from "./../../services/api";
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import * as moment from "moment";
import { FacilityTypes } from "./../../models/facitlity-types";
import { ElementRef, NgZone, ViewChild } from "@angular/core";
import { } from "googlemaps";
import { MapsAPILoader } from "@agm/core";
import { MatSnackBar } from "@angular/material";
@Component({
  templateUrl: "./profile.component.html"
})
export class ClubProfileComponent implements OnInit {
  public club: any;
  public user: any;
  public form: FormGroup;
  public list: Array<any>;
  public offerList: Array<any>;
  public courses: Array<any>;
  public imageLoader = true;
  public disabled: boolean;
  public avatarLoading: boolean;
  public coverLoading: boolean;
  public facilityList: Array<any>;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public address: string;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    private mapsAPILoader: MapsAPILoader,
    public snackBar: MatSnackBar,
    private ngZone: NgZone
  ) {
    this.offerList = [];

    this.club = this.oAuthService.getClub();
  }

  ngOnInit() {
    this.initData();
    this.zoom = 4;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    this.setCurrentPosition();

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"]
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // console.log(place)
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.club.address = place.formatted_address;
          const results = place.address_components;
          this.form.patchValue({ address: this.club.address });

          this.form.patchValue({
            city: this.findResult(results, "administrative_area_level_2")
          });
          this.club.state = this.findResult(
            results,
            "administrative_area_level_1"
          );
          this.club.country = this.findResult(results, "country");
          this.form.patchValue({
            postCode: this.findResult(results, "postal_code")
          });
          this.club.location.lat = place.geometry.location.lat();
          this.club.location.lon = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  public onAddressChange(val) {
    console.log(val);
  }
  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  public initData() {
    this.club = this.oAuthService.getClub();
    this.user = this.club
    if (this.club.address) {
      this.address = this.club.address;
    }
    this.form = new FormGroup({
      name: new FormControl(this.club.name, Validators.required),
      db_phone: new FormControl(
        this.club.db_phone,
        Validators.pattern("[0-9 ]+")
      ),
      info: new FormControl(this.club.info), //Club info
      address: new FormControl(this.club.address, Validators.required),
      websiteLink: new FormControl(this.club.websiteLink), // website

      city: new FormControl(this.club.city, Validators.required),
      postCode: new FormControl(this.club.postCode), //postcode
      contactPersonName: new FormControl(
        this.club.contactPersonName,
        Validators.required
      ),
      contactPersonEmailId: new FormControl(
        this.club.contactPersonEmailId,
        Validators.required
      )
    });
    this.disabled = false;
    this.avatarLoading = false;
    this.coverLoading = false;
    this.facilityList = [];
    lodash.forEach(FacilityTypes, (item, key) => {
      this.facilityList.push({ id: key, name: item, isAvailable: false });
    });
    this.apiService.object(`/users/${this.club.cid}`).then(club => {
      this.club = club;
      if (!this.club.commission) {
        this.club.commission = 10;
      }
      console.log(this.club.postCode);
      this.form = new FormGroup({
        name: new FormControl(this.club.name, Validators.required),
        db_phone: new FormControl(
          this.club.db_phone,
          Validators.pattern("[0-9 ]+")
        ),
        websiteLink: new FormControl(
          this.club.websiteLink
        ),

        info: new FormControl(this.club.info),
        address: new FormControl(this.club.address),
        city: new FormControl(this.club.city, Validators.required),
        postCode: new FormControl(this.club.postCode),
        contactPersonName: new FormControl(
          this.club.contactPersonName,
          Validators.required
        ),
        contactPersonEmailId: new FormControl(
          this.club.contactPersonEmailId,
          Validators.required
        )
      });
      if (this.club.courses) {
        this.courses = [];

        lodash.forEach(this.club.courses, (item: any, key) => {
          const course = {
            name: item.name,
            holes: item.holes,
            $key: key,
            tees: []
          };

          lodash.forEach(item.tees, (tee: any, key1) => {
            course.tees.push({
              name: tee.name,
              color: tee.color,
              $key: key1
            });
          });
          
          this.courses.push(course);
        });
      }

      lodash.forEach(this.club.facility, (item, key) => {
            for (var i = 0; i < this.facilityList.length; i++) {
              if (key == this.facilityList[i].id) {
                this.facilityList[i].isAvailable = true;
              }
            }
      });
      
      this.imageLoader = false;
    });
  }
  public changeAvatar(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.user.cid}_${moment().unix()}.${fileExt}`;

    this.avatarLoading = true;
    this.apiService
      .upload("/users/avatars", fileName, file, {
        customMetadata: { uid: this.user.cid }
      })
      .then(result => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.avatarLoading = false;
            this.club.avatar = result.downloadURL;
            this.club.avatar_thumb = result.downloadURL;
             let ob = {
              avatar: this.club.avatar,
              avatar_thumb: this.club.avatar_thumb 
             }
             this.apiService
            .update(`/users/${this.user.cid}`, ob)
            .then(() => {
              this.initData();
              this.disabled = false;
              $("#myModal").modal("hide");
              $(".modal-backdrop").hide();
              this.snackBar.open("Avatar updated successfully!!", "OK!", {
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);

              this.disabled = false;
            });
          };
          image.onerror = () => {
            this.avatarLoading = false;
          };
        } else {
          this.avatarLoading = false;
        }
      })
      .catch(error => {
        console.error(error);

        this.avatarLoading = false;
      });
  }

  public changeBackground(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.user.cid}_${moment().unix()}.${fileExt}`;

    this.coverLoading = true;
    this.apiService
      .upload("/users/background", fileName, file, {
        customMetadata: { uid: this.user.cid }
      })
      .then(result => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.coverLoading = false;
            this.club.background = result.downloadURL;
             let ob = {
              background: this.club.background,
            }
             this.apiService
            .update(`/users/${this.user.cid}`, ob)
            .then(() => {
              this.initData();
              this.disabled = false;
              $("#myModal").modal("hide");
              $(".modal-backdrop").hide();
              this.snackBar.open("Background updated successfully!!", "OK!", {
                duration: 3000,
              });
            }).catch(() => {})
          };
          image.onerror = () => {
            this.coverLoading = false;
          };
        } else {
          this.coverLoading = false;
        }
      })
      .catch(error => {
        console.error(error);

        this.coverLoading = false;
      });
  }

  submit() {
    const facility = [];
    lodash.forEach(this.facilityList, async data => {
      const isAvailable = data.isAvailable;
      const id = data.id;
      const obj = {id: data.id, name: data.name};
      await this.facilitySelect(isAvailable, obj);
      obj[id] = isAvailable;
      facility.push(obj);
    });

    const ob = {
      info: this.form.controls["info"].value ? this.form.controls["info"].value : null,
      db_phone: this.form.controls["db_phone"].value + "" ? this.form.controls["db_phone"].value + "": null,
      address: this.form.controls["address"].value ? this.form.controls["address"].value : null,
      contactPersonName: this.form.controls["contactPersonName"].value,
      updatedAt: new Date().getTime() / 1000,
      websiteLink: this.form.controls["websiteLink"].value ? this.form.controls["websiteLink"].value : null,
      state: this.club.state ? this.club.state : null,
      city: this.form.controls["city"].value,
      country: this.club.country ? this.club.country : null,
      postCode: this.form.controls["postCode"].value ? this.form.controls["postCode"].value: null,
      location: this.club.location ? this.club.location : null,
      contactPersonEmailId: this.form.controls["contactPersonEmailId"].value
    };
    console.log(ob);
    this.disabled = true;
    this.apiService
      .update(`/users/${this.user.cid}`, ob)
      .then(() => {
        this.initData();
        this.disabled = false;
        $("#myModal").modal("hide");
        $(".modal-backdrop").hide();
      })
      .catch(error => {
        console.error(error);

        this.disabled = false;
      });
  }
  public close() {
    this.initData();
  }
  public async facilitySelect(event, facility) {
    console.log(event);
    console.log(facility);
    if (event) {
      this.apiService
        .set(`/users/${this.club.cid}/facility/${facility.id}`, facility.name)
        .then(() => { })
        .catch(error => {
          console.error(error);
        });
    } else {
      this.apiService
        .set(`/users/${this.club.cid}/facility/${facility.id}`, null)
        .then(() => { })
        .catch(error => {
          console.error(error);
        });
    }
  }
}
